import React from 'react';
import Logo from '@assets/icons/logo-login-icon.svg';
import { Toolbar, Button, Box } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
import { AppBar, LogoImage } from './styled';

const LoggedOutMenu = () => {
	const navigate = useNavigate();
	const lan = useLanguage();
	return (
    <AppBar position="fixed" elevation={0}>
      <Toolbar disableGutters sx={{ px: 2 }}>
        {/* Left: brand/logo */}
        <Box
          component="a"
          href="https://www.appfielder.com"
          aria-label="AppFielder home"
          sx={{ display: 'inline-flex', alignItems: 'center' }}
        >
          <LogoImage src={Logo} alt="AppFielder" />
        </Box>
        {/* Right: login */}
        <Button
          id="navbar-login-button"
          color="inherit"
          onClick={() => navigate(ENDPOINTS.login)}
          sx={{ ml: 'auto', textTransform: 'none', fontWeight: 600 }}
        >
          {lan.getInto}
        </Button>
      </Toolbar>
    </AppBar>
	);
};

export default LoggedOutMenu;
